export const rubrosHistoricos = [
   {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/Transparencia/zip/1erTrimestre2025SECTURH.zip"
            },
             {
                "trimestre" : "Segundo Trimestre",
                "url" : "/Transparencia/zip/2doTrimestre2025SECTURH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/Transparencia/zip/3erTrimestre2025SECTURH.zip"
            }/*,
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/Transparencia/zip/4toTrimestre2024SECTURH.zip"
            }*/
        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/Transparencia/zip/1erTrimestre2024SECTURH.zip"
            },
             {
                "trimestre" : "Segundo Trimestre",
                "url" : "/Transparencia/zip/2doTrimestre2024SECTURH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/Transparencia/zip/3erTrimestre2024SECTURH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/Transparencia/zip/4toTrimestre2024SECTURH.zip"
            }
        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/Transparencia/zip/1erTrimestre2023SECTURH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/Transparencia/zip/2doTrimestre2023SECTURH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/Transparencia/zip/3erTrimestre2023SECTURH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/Transparencia/zip/4toTrimestre2023SECTURH.zip"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/Transparencia/zip/1erTrimestre2022SECTURH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/Transparencia/zip/2doTrimestre2022SECTURH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/Transparencia/zip/3erTrimestre2021SECTURH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/Transparencia/zip/4toTrimestre2021SECTURH.zip"
            }
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/Transparencia/zip/1erTrimestre2021SECTURH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/Transparencia/zip/2doTrimestre2021SECTURH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/Transparencia/zip/3erTrimestre2021SECTURH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/Transparencia/zip/4toTrimestre2021SECTURH.zip"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/Transparencia/zip/1erTrimestre2020SECTURH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/Transparencia/zip/2doTrimestre2020SECTURH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/Transparencia/zip/3erTrimestre2020SECTURH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/Transparencia/zip/4toTrimestre2020SECTURH.zip"
            }
        ]
    },
    {
        "anio" : "2019",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/Transparencia/zip/1erTrimestre2019SECTURH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/Transparencia/zip/2doTrimestre2019SECTURH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/Transparencia/zip/3erTrimestre2019SECTURH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/Transparencia/zip/4toTrimestre2019SECTURH.zip"
            }
        ]
    },
    {
        "anio" : "2018",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/Transparencia/zip/1erTrimestre2018SECTURH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/Transparencia/zip/2doTrimestre2018SECTURH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/Transparencia/zip/3erTrimestre2018SECTURH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/Transparencia/zip/4toTrimestre2018SECTURH.zip"
            }
        ]
    },
    {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.inai.org.mx/vut-web/faces/view/consultaPublica.xhtml#sujetosObligados"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "/Transparencia/zip/InformacionHistorica21Rubros.zip"
            }
        ]
    }
]